import { Theme, useMediaQuery } from '@mui/material';

/**
 * Czy sidebar dziala w trybie mobilnym (wysuwany Drawer), a nie zadokowanym.
 *
 * To DOKLADNIE ten sam warunek, ktorego react-admin uzywa w swoim `Sidebar`
 * do wyboru `variant="temporary"` (patrz ra-ui-materialui/layout/Sidebar).
 * Musi byc jednym zrodlem prawdy dla wszystkiego, co reaguje na tryb mobilny
 * sidebara — inaczej przy szerokosci granicznej jedna czesc UI uwaza, ze jest
 * mobilnie, a druga, ze nie.
 *
 * Wczesniej `Menu` pytal o `'(max-width:600px)'`, a `Sidebar` o
 * `breakpoints.down('sm')` (czyli `max-width: 599.95px`). Przy dokladnie 600px
 * te warunki daja rozne odpowiedzi: drawer jest juz wysuwany i zaslania pasek
 * gorny, ale przycisk zamykania sie nie renderuje — i nie da sie go zamknac.
 */
export const useIsMobileSidebar = (): boolean =>
  useMediaQuery<Theme>((theme) => theme.breakpoints.down('sm'));
